<template>
  <div
    class="news-card-wrapper d-flex d-flex-lg-column"
    @click="navigateToNewsPost()"
  >
    <img
      v-if="imgUrl"
      class="card-img mr-3"
      :src="imgUrl"
      alt="News image"
      @error="handleImgLoadError"
    />
    <div class="card-body px-0 py-0">
      <div v-if="postData" class="pb-1">
        <news-card-details
          :date="postData.date"
        />
      </div>
      <div class="line-clamp"><h4>{{ postData.title }}</h4></div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";

import NewsCardDetails from "./NewsCardDetails";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import SharepointMixin from "@/mixins/SharepointMixin";

export default {
  name: "news-card",
  props: ["postData"],
  mixins: [HomebaseMixpanelMixin, SharepointMixin],
  components: {
    NewsCardDetails,
  },
  data() {
    return {
      CONSTANTS,
      imgUrl: CONSTANTS.FALLBACK_ADSK_LOGO_IMG_URL
    }
  },
  created() {
    this.initializeNewsCard();
  },
  methods: {
    async initializeNewsCard() {
      try {
        this.imgUrl = this.postData.imageUrl
      } catch(e) {
        this.handleImgLoadError();
      }
    },

    navigateToNewsPost() {
      let title = this.postData.title;
      let url = this.postData.url;

      this.trackTopStoryClick(`${title} - ${url}`);
      window.open(url, Vue.prototype.$getAoneLinkTarget(url));
    },

    handleImgLoadError() {
      this.imgUrl = CONSTANTS.FALLBACK_ADSK_LOGO_IMG_URL;
    }
  },
};
</script>

<style scoped>
.news-card-wrapper:hover {
  cursor: pointer;
}
.card-img {
  border-radius: 5px;
  max-width: 110px;
  height: 110px;
  object-fit: cover;
  object-position: 50% 35%;
}
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/news/NewsCard.vue